111/**
    商品列表
**/
<template>
  <div class="rightaside_content">
    <h3 class="headerTitle">我的红包</h3>
    <el-tabs type="border-card">
      <el-tab-pane label="未使用的红包">
        <span slot="label">未使用的红包</span>
        <el-row>
          <el-col
            :xs="12"
            :sm="6"
            :md="6"
            :lg="6"
            v-for="(item, index) in envelopeList"
            :key="index"
            class="bigoutBox"
            v-loading="loading"
          >
            <div class="wholeBox">
                <div class="coupon-header"></div>
                <div class="coupon-content">
                    <div class="item-value">
                      <span class="value">{{item.redenvelopesPrice}}</span>元
                    </div>
                    <div class="item-desc">{{item.mid?item.store_name:'通用红包'}}</div>
                </div>
                <div class="item-description">
                    <p>适用范围：满{{item.subtotal}}元使用</p>
                </div>
                <div class="coupon-footer">
                    <div class="coupon-date">{{item.activityEndtime}}前有效</div>
                </div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <div class="nodate" v-if="envelopeList.length == 0 ? true : false">
            <div class="first">您还没有相关的优惠券</div>
            <div class="second">店铺红包可享受商品优惠</div>
          </div>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="已失效红包">
        <span slot="label">已失效红包 <i></i></span>
        <el-row>
          <el-col
            :xs="12"
            :sm="6"
            :md="6"
            :lg="6"
            v-for="(item, index) in envelopeListed"
            :key="index"
            class="bigoutBox"
            v-loading="loading"
          >
            <div class="wholeBox graybg">
                  <div class="gary_header"></div>
                  <div class="coupon-content">
                      <div class="item-value">
                        <span class="value">{{item.redenvelopesPrice}}</span>元
                      </div>
                      <div class="item-desc">{{item.mid?item.store_name:'通用红包'}}</div>
                  </div>
                  <div class="item-description">
                      <p>适用范围：满{{item.subtotal}}元使用</p>
                  </div>
                  <div class="graycoupon-footer">
                      <div class="coupon-date">{{item.activityEndtime}}前有效</div>
                  </div>
            </div>
          </el-col>
        </el-row>
        <div class="nodate"  v-if="envelopeListed.length == 0 ? true : false">
          <div class="first">未找到相应红包。</div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="已使用红包">
        <span slot="label">已使用红包 </span>
        <el-row>
          <el-col
            :xs="12"
            :sm="6"
            :md="6"
            :lg="6"
            v-for="(item, index) in envelopeListUsed"
            :key="index"
            class="bigoutBox"
            v-loading="loading"
          >
            <div class="wholeBox graybg">
                  <div class="gary_header"></div>
                  <div class="coupon-content">
                      <div class="item-value">
                        <span class="value">{{item.redenvelopesPrice}}</span>元
                      </div>
                      <div class="item-desc">{{item.mid?item.store_name:'通用红包'}}</div>
                  </div>
                  <div class="item-description">
                      <p>适用范围：满{{item.subtotal}}元使用</p>
                  </div>
                  <div class="graycoupon-footer">
                      <div class="coupon-date">{{item.activityEndtime}}前有效</div>
                  </div>
            </div>
          </el-col>
        </el-row>
        <div class="nodate"  v-if="envelopeListUsed.length == 0 ? true : false">
          <div class="first">未找到相应红包。</div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { getMyred } from "@/api/xunyou";
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      loading: false,
      envelopeList: [], // 未使用
      envelopeListUsed: [], // 已使用
      envelopeListed: [], // 失效
    };
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted() {
    // 1:未使用 2.已使用,3.失效的
    this.searchRedEnvelope(1);
    this.searchRedEnvelope(2);
    this.searchRedEnvelope(3);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 红包查询
    searchRedEnvelope(type) {
      const req = {
        muid:this.userInfo.userId,
        status:type,
        
      }
      getMyred(req)
        .then((res) => {
          if (res.code == 0) {
            if(type==1){
              this.envelopeList = res.rows;
            }else if(type==2){
              this.envelopeListUsed = res.rows;
            }else if(type==3){
              this.envelopeListed = res.rows;
            }
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("查询红包失败，请稍后再试！");
        });
    },
  },
};
</script>

<style scoped lang="less">
.rightaside_content {
  .headerTitle {
    font-size: 20px;
    height: 40px;
    line-height: 40px;
    color: #666;
  }
  /deep/.el-tabs--border-card {
    border: 0px;
    box-shadow: unset;
    .el-tabs__header {
      border-bottom: 0px;
      background: white;
      /deep/ .el-tabs__item.is-active {
        color: #78b942;
        background-color: transparent;
        border-right-color: transparent;
        border-left-color: transparent;
      }
    }
  }
  .search_box {
    text-align: right;
    margin-bottom: 10px;
    .input-with-select.el-input.el-input-group.el-input-group--append {
      width: 40%;
    }
  }
  .tab_pane_content {
    .noData {
      text-align: center;
      height: 200px;
      line-height: 200px;
    }
  }
  .bigoutBox {
    margin-right: 10px;
  }
  .wholeBox {
    // display: flex;
    // justify-content: flex-start;
    // width: 180px;
    // height: 126px;
    // border: 1px solid #eaeaea;
    margin-bottom: 10px;
    box-sizing: border-box;
    background: #ff6709;
    // background: #ff6709;
    .coupon-header{
        background: url('../../../assets/img/redColor.jpg') no-repeat;
        height: 14px;
        width: 100%;
        background-size: 100%;
        background-position: top;
    }
    .coupon-content {
        text-align: center;
        word-break: break-all;
        padding: 32px 40px 0;
        background: #ff6709;
        color:white;
       .item-desc {
            padding: 15px;
            // height: 45px;
        }
        .item-value {
            font-size: 16px;
            color: #fff;
            border-bottom: 2px solid #fff;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            .value {
                font-size: 40px;
                font-weight: 200;
                line-height: 1;
                
            }
        }
    }
    .item-description {
        font-size: 12px;
        color: #b0b0b0;
        height: 90px;
        background: #f5f5f5;
        padding: 0 20px;
        margin: 0 2px;
        vertical-align: middle;
        line-height: 90px;
    }
    .coupon-footer {
        background: url('../../../assets/img/redColor.jpg') 0 -19px no-repeat;
        margin-top: 37px;
        height: 14px;
        position: relative;
        background-size: 100%;
        background-position: bottom;
        .coupon-date {
          font-size: 12px;
          color: #fff;
          position: relative;
          width: 100%;
          top: -31px;
          text-align: center;
      }
    }
    
  }
  .graybg{   
    background: #b0b0b0;
    .gary_header{
      background: url('../../../assets/img/grayColor.jpg') no-repeat;
      height: 14px;
        width: 100%;
        background-size: 100%;
        background-position: top;
    }
    .coupon-content {
      background: #b0b0b0;
    }
    .graycoupon-footer{
      background: url('../../../assets/img/grayColor.jpg') 0 -19px no-repeat;
      margin-top: 37px;
        height: 14px;
        position: relative;
        background-size: 100%;
        background-position: bottom;
        .coupon-date {
          font-size: 12px;
          color: #fff;
          position: relative;
          width: 100%;
          top: -31px;
          text-align: center;
      }
    }
  }
  .img-responsive {
    width: 45%;
    padding: 10px;
    text-align: center;
    // line-height: 100px;
  }
  .getNow {
    /* width: 132px;
                height: 40px; */
    margin-top: 1px;
    background-color: #d93600;
    padding: 7px 15px;
    font-size: 15px;
    color: white;
  }
  button.el-button.buttonBgd.el-button--primary {
    color: #fff;
    background-color: #78b942;
    border-color: #e65d00;
    width: 180px;
    margin-left: 12px;
    margin-top: 5px;
    font-size: 14px;
  }
  .dialogBox .textCenter {
    text-align: center !important;
    font-size: 24px !important;
  }
  .first {
    margin: 40upx 0 12upx;
    font-size: 28upx;
  }

  .second {
    font-size: 24upx;
    color: #999;
  }
  .nodate {
    text-align: center;
    font-size: 16px;
  }
  span.noimg {
    display: inline-block;
    width: 100%;
    height: 90px;
    line-height: 90px;
    background: #ccc;
  }
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/myOrder/propertyCenter/myRedPack.vue